import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
//Create custom component to export
var CarFeaturesReadOnly = function CarFeaturesReadOnly(props, _ref) {
  var $h = _ref.$h,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var list = props.list;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div>
${list.length > 0 && $h`
  ${list.map((item) => $h`
    ${item.isUsed > 0 ? $h`
  <div class="chip">
    ${item.iconType == 1 && $h`
    <div class="chip-media bg-color-blue ${item.type == 0 ? $h`icon-adjust`:$h``}">
      <i class="icon material-symbols-outlined">${item.iconImage}</i>
    </div>
    `}
    ${item.iconType == 2 && $h`
    <div class="chip-media bg-color-blue ${item.type == 0 ? $h`icon-adjust`:$h``}">
      <img class="" width="50px" height="50px" src="/static/icons/features/${item.iconImage}"/> 
    </div>
    `}
    ${item.type == 0 && $h`
    <div class="chip-media bg-color-${item.value > 0 ? $h`green`:$h`red`}">
      <i class="icon material-symbols-outlined">${item.value > 0 ? $h`done`:$h`close`}</i>
    </div>
    `}
    ${(item.type > 0) ? $h`
    <div class="chip-label">${item.name}: ${item.value}</div>`:$h`<div class="chip-label">${item.name}</div>
    `}
  </div>
    `:$h`
  <span></span>
    `}
  `)}
`}
</div>
`
    }
    ;
};
//Export component name
export default CarFeaturesReadOnly;

//On template use:
//<${ListItem} title="Item 2" />